import { mixins, styled } from '@bob/library'

export const Wrapper = styled.div`
  max-width: 700px;
  margin: 0 auto;
  ${mixins.padding(0, 10)}
`

export const LearnMoreButtonWrapper = styled.div`
  ${mixins.margin(30)}
`
